(function () {
    'use strict';

    angular.module('processModule')
        .controller('area-detail.controller', areaDetailController);

    areaDetailController.$inject = ['$stateParams', 'routeService', '$sce', 'pubSub'];
    function areaDetailController($stateParams, routeService, $sce, pubSub) {
        var vm = this;
        vm.initialize = initialize;
        vm.areaId = $stateParams.areaId;
        vm.areaDetailIframe = '';

        initialize();

        function initialize() {
            vm.areaDetailIframe = $sce.trustAsResourceUrl(routeService.getBaseRouteProcess() + 'area/detail/' + vm.areaId + '?isFrontend=true');

            pubSub.publish(broadcastType.processAreaRouteChanged, {
                areaId: vm.areaId
            });
        }
    };

})();